import SparkMD5 from 'spark-md5';
import stringify from 'fast-json-stable-stringify';
import store from '../reducers/storeRegistration';
import serverNativeBehaviorEvaluator from './serverNativeBehaviorEvaluator';
import { actionRegistrar } from '../actions/entityActionRegistrar';

// Cache key prefix for queryFormBehavior entries
const CACHE_KEY_PREFIX = 'queryFormBehavior_';

/**
 * Generate a deterministic cache key from source parameters
 * Uses MD5 hash with fast-stable-stringify for consistent ordering
 * Handles null/undefined source values gracefully
 */
const generateCacheKey = source => {
  // Handle null/undefined source values
  const safeSource = source !== null && source !== void 0 ? source : {};

  // Use fast-stable-stringify to ensure consistent property ordering
  const sourceString = stringify(safeSource);
  const hash = SparkMD5.hash(sourceString);
  return `${CACHE_KEY_PREFIX}${hash}`;
};

/**
 * Manage a web cache of queryFormBehavior results
 * This web native behavior wraps the server queryFormBehavior with client-side caching
 * Cache is automatically cleared when forms are unloaded via clearEditorCache
 * @param {Object} entity - The entity object
 * @param {string} entityName - The name of the entity
 * @param {Object} source - The query source object to be passed to the server evaluator
 *  and also used to generate a cache key.
 * @param {Object} content - The content object
 * @param {string} parentContentPath - The parent content path
 * @param {Object} transientContext - The transient context object
 * @param {Object} nativeFunctions - The native functions object
 * @param {Object} sourceEvaluator - The source evaluator object
 * @returns {*} The query result from the cache or server
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const cacheKey = generateCacheKey(source);
  const state = store.getState();
  const {
    editorCache = {}
  } = state[entityName] || {};
  const cacheEntry = editorCache[cacheKey];

  // Check cache first
  if (cacheEntry) {
    return cacheEntry;
  }

  // Cache miss - call server
  const result = await serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);

  // Store in cache
  const entityActions = actionRegistrar(entityName);
  store.dispatch(entityActions.setEditorCacheValue(cacheKey, result));
  return result;
};
export default {
  evaluate
};